/** Anzeige der Download-Übersicht eines Dokuments (Lupen-Symbol „Anzahl
 *  Downloads" in der Dokumentzeile). */
import {
  formatBackendDateTime,
  NO_TIMESTAMP,
} from './backendTimestamp.service';

/** Download-Zeitpunkt als deutsche Ortszeit, z. B. `26.08.2026, 12:10:15`.
 *  Fehlt der Wert oder ist er unlesbar, steht `k.A.` — wie bisher. */
export const formatDownloadTimestamp = (
  raw: string | null | undefined
): string => {
  const formatted = formatBackendDateTime(raw);
  // Eigener Platzhalter: die Spalte trug schon vorher "k.A.", nicht den
  // Gedankenstrich des gemeinsamen Helfers.
  return formatted === NO_TIMESTAMP ? 'k.A.' : formatted;
};

/** Satzende über der Tabelle. Vorher stand dort bei jeder Anzahl „wurde
 *  insgesamt N heruntergeladen" — bei 0 ergab das keinen Satz. */
export const downloadCountSentence = (count: number): string => {
  if (count <= 0) return 'wurde noch nicht heruntergeladen.';
  if (count === 1) return 'wurde einmal heruntergeladen:';
  return `wurde insgesamt ${count}-mal heruntergeladen:`;
};
